<template>
  <!-- T1006282 使用微信开放标签跳转微信小程序，需要把此项目的h5域名配置在微信开放平台（因为需要签名这个标签才会显示出来），用这种方式跳转到的小程序不需要配合配置，只需要拿到微信小程序的appId和path即可,开发者工具跳转不了，需要用手机测试 微信文档：https://developers.weixin.qq.com/doc/service/guide/h5/opentag.html#%E5%BC%80%E6%94%BE%E6%A0%87%E7%AD%BE -->
  <wx-open-launch-weapp
    :username="username"
    :path="path"
    style="width: 100%; display: block;"
  >
    <script type="text/wxtag-template">
      <style>
        .launch-btn {
          color: #c69528;
          font-size: 14px;
          text-align: center;
          margin: 20px auto 0px;
          padding: 20px 0px 0px;
          border-top: 1px dashed rgb(255, 255, 255);
          font-weight: bold;
          border-bottom: none;
          border-left: none;
          border-right: none;
          display: flex;
          justify-content: center;
          align-items: center;
          background: transparent;
          width: 93%;
        }
      </style>
      <button class="launch-btn">点击跳转小程序去使用 → </button>
    </script>
  </wx-open-launch-weapp>
</template>

<script>
export default {
  name: 'WxLaunchWeapp',
  props: {
    username: {
      type: String,
      required: true
    },
    path: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped></style>
